


export const types = {
    isBarActive : '[SideBar] Active',
    isBarInactive : '[SideBar] Inactive',
    isSearchActive : '[Search] Active',
    isSearchInactive : '[Search] Inactive',
  }